module.exports = require('./helpers/bundle-url').getBundleURL('9KyVe') + "logo-dark.eefe0b7f.svg";